import React from 'react';
import PropTypes from 'prop-types';
import { Button, Row, Col } from 'react-bootstrap';
import './styles.css';
import { connect } from '../../reducers/index';
import { url } from '../../constants/routes';
import Navigation from '../../components/Navigation';
import Footer from '../../components/Footer';

const SitemapPage = props => (
  <div className="site-map-page">
    <Navigation role={props.role} />
    <section>
      <div id="maincontent" className="container entry-content">
        <Row>
          <Col xs={12} md={8} mdOffset={2}>
            <h1 className="txt-blue">Sitemap</h1>
            <ul>
              <li><a href={url.WELCOME}>Welcome</a></li>
              <li><a href={url.MODULE}>Training</a></li>
              <li><a href={url.RESOURCES}>Resources</a></li>
              <li><a href={url.REFERENCE}>Quick Guide</a></li>
              <li><a href={url.SITEMAP} aria-current="page">Sitemap</a></li>
            </ul>
          </Col>
        </Row>
      </div>
    </section>
    <Footer />
  </div>
);

SitemapPage.propTypes = {
  role: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types
};

const Sitemap = connect.role(SitemapPage);

export default Sitemap;



// WEBPACK FOOTER //
// ./src/containers/Sitemap/index.jsx